export const inviteUserModalSx = {
  dialogPaper: {
    borderRadius: '6px'
  },

  dialogContent: {
    px: 2
  },

  accountSection: {
    pt: 1.8,
    pb: 2
  },

  sectionTitle: {
    mb: 0.5,
    color: '#424242',
    fontSize: 13,
    fontWeight: 500
  },

  accountTypeRadioGroup: {
    mb: 1.5,
    columnGap: 1,
    rowGap: 1
  },

  accountTypeRadio: {
    color: '#757575',

    '&.Mui-checked': {
      color: '#4A90D9'
    }
  },

  accountTypeLabelWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.8
  },

  accountTypeLabel: {
    color: '#424242',
    fontSize: 13,
    fontWeight: 400
  },

  formControlLabel: {
    m: 0,

    '& .MuiFormControlLabel-label': {
      display: 'flex'
    }
  },

  tooltip: {
    maxWidth: 240,
    bgcolor: '#616161',
    fontSize: 10,
    lineHeight: 1.5,
    fontWeight: 400,
    px: 1,
    py: 1
  },

  tooltipArrow: {
    color: '#616161'
  },

  medicalProviderInfoIcon: {
    color: '#757575',
    fontSize: 18,
    cursor: 'pointer',

    '&:hover': {
      color: '#4A90D9'
    }
  },

  clinicalStaffInfoIcon: {
    color: '#757575',
    fontSize: 18
  },

  adminPrivilegeSection: {
    mt: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    gap: 2
  },

  adminPrivilegeLabelWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.6
  },

  adminPrivilegeLabel: {
    color: '#616161',
    fontSize: 14,
    fontWeight: 500
  },

  requiredAsterisk: {
    color: '#D32F2F',
    ml: 0.25
  },

  adminInfoIcon: {
    color: '#757575',
    fontSize: 18,
    fontWeight: 400,
    cursor: 'pointer',

    '&:hover': {
      color: '#1976D2'
    }
  },

  adminRadioGroup: {
    columnGap: 1,
    rowGap: 1
  },

  adminRadio: {
    color: '#757575',

    '&.Mui-checked': {
      color: '#4A90D9'
    }
  },

  adminOptionLabel: {
    m: 0,

    '& .MuiFormControlLabel-label': {
      fontSize: 13,
      color: '#424242'
    }
  },

  userInformationSection: {
    pt: 1.8,
    pb: 2
  },

  userInformationTitle: {
    mb: 1,
    color: '#424242',
    fontSize: 13,
    fontWeight: 500
  }
};